import React from "react";
import { useField, useFormikContext } from "formik";
import { Autocomplete, CircularProgress, debounce, TextField } from "@mui/material";

const AutoCompleteSearchWrapper = ({ freeSolo, disabled, name, fetchData, label, data, ...otherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, mata] = useField(name);

  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const fetch = React.useMemo(
    () =>
      debounce(async (input, data) => {
        let formData = {
          value: input,
        };
        if (input.length > 0) {
          const response = await fetchData(formData, data);
          if (response?.isSuccess) {
            setOptions(response?.data);
            setIsLoading(false);
          } else {
            setOptions([]);
            setIsLoading(false);
          }
        } else {
          const response = await fetchData(formData, data);
          if (response?.isSuccess) {
            setOptions(response?.data);
            setIsLoading(false);
          } else {
            setOptions([]);
            setIsLoading(false);
          }
        }
      }, 500),
    []
  );

  React.useEffect(() => {
    setIsLoading(true);
    fetch(inputValue, data);
  }, [inputValue]);

  const configAutocomplete = {
    ...field,
    ...otherProps,
    variant: "outlined",
    fullWidth: true,
  };

  if (mata && mata.touched && mata.error) {
    configAutocomplete.error = true;
    configAutocomplete.helperText = mata.error;
  }

  return (
    <Autocomplete
      // freeSolo={freeSolo}
      fullWidth
      sx={{ mt: 1 }}
      filterOptions={(x) => x}
      options={options}
      autoComplete
      disabled={disabled}
      includeInputInList
      value={field?.value || null}
      filterSelectedOptions
      noOptionsText="Search not found"
      isOptionEqualToValue={(option, value) => {
        if (typeof value === "string") {
          return false;
        } else {
          return option?.value === value?.value;
        }
      }}
      onChange={(event, value) => {
        setFieldValue(name, value === null ? "" : value);
        // setFieldValue(name, value?.label);
      }}
      onInputChange={(event, value) => {
        setInputValue(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          {...configAutocomplete}
          disabled={disabled}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {inputValue.length > 0 && isLoading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default AutoCompleteSearchWrapper;
